import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

// // // LIST ALL APPLICATIONS FROM JOBS
export const applicationList = params => Http.get(`/vacancy-application${serialize(params)}`)

// // // LIST APPLICATIONS FROM ID
export const applicationByID = (params = '') => Http.get(`/vacancy-application/${params}`)
export const applicationStatusList = (params = '') => Http.get(`/vacancy-application${serialize(params)}`)

// // // ADMIN: LIST CANDIDATES OF A VACANCY
export const vacancyCandidates = (vacancyId, params = '') =>
	Http.get(`/admin/vacancies/${vacancyId}/candidates${serialize(params)}`)

// // // ADMIN: LIST USER INTERACTIONS (views + external clicks) FOR A VACANCY
export const vacancyInteractions = (vacancyId, params = '') =>
	Http.get(`/admin/vacancies/${vacancyId}/interactions${serialize(params)}`)
